export default __webpack_public_path__ + "static/media/team3.de79a130.jpg";